var PanoSlider = {
	node :null,
	idx: 0,
	imgs: [],
	cycling: false,
	nextCycle: null,

	init: function() {
		if (PROJECT.settings['slider'] == "0") return;
		
		/*
		Tab.add("bottom", {
			"focus": function(m) {
				//console.log("focus szybka prezentacja");
				$(".sliderbutton").addClass("focused");
				$(".sliderbutton").focus();
			},

			"blur": function(m) {
				//console.log("blur szybka prezentacja");
				$(".sliderbutton").removeClass("focused");
			}
		}, {});
		*/


		PanoSlider.node = $("<div id='panoslider'><div class='photoholder'><div class='top'><div class='gps'></div><div class='counter'></div><div class='id'></div></div><div class='bottom'><div class='title'></div><div class='control'><a href='javascript:void(null)'  onclick='PanoSlider.previous();' class='l'><i class='fa fa-chevron-left'></i></a> <a href='javascript:void(null)' onclick='PanoSlider.togglecycle();' class='t'><i class='fa fa-pause'></i></a> <a href='javascript:void(null)' onclick='PanoSlider.next();' class='r'><i class='fa fa-chevron-right'></i></a></div></div></div><a href='javascript:void(null);' onclick='PanoSlider.close();' class='closepanel'><img src='assets/menu_close.png'></a></div>");
		PanoSlider.button = $("<a href='javascript:void(null);' aria-hidden='true' title='" + TPL.lng("slider_button", "Szybka prezentacja") + "' onclick='PanoSlider.show();' class='sliderbutton' data-speak='PLAYER.OPEN_SLIDER' data-speakgroup='TIPS'>" + TPL.lng("slider_button", "Szybka prezentacja") + "</a>");
		
		if (!Screen.xs()) $("#overlay .tray").append(PanoSlider.button);

		Tab.add("bottom", Tab.simpleTab($(".sliderbutton"), 1), {});

		PanoSlider.loader = $("<div class='loader'><img src='assets/loader.svg'></div>");
		//PanoSlider.node.append(PanoSlider.loader);

		AppEvent.on(player, "PLACE.LOADED", PanoSlider.placeLoaded);
		
		SpeechManager.enableSpeech("#overlay", ".sliderbutton", 1, "TOPMENU");

		/*
		var langsLoaded = function() {
			if (TPL.lng("PLAYER.PLAYER.OPEN_SLIDER") != undefined && TPL.lng("PLAYER.PLAYER.OPEN_SLIDER") != "") {
				$("#overlay").append(PanoSlider.button);
			} else
				setTimeout(langsLoaded, 300);
		};		
		
		setTimeout(langsLoaded, 300);
		*/

		PanoSlider.counter = PanoSlider.node.find(".counter");
		PanoSlider.title = PanoSlider.node.find(".title");
		PanoSlider.gps = PanoSlider.node.find(".gps");
		PanoSlider.idlabel = PanoSlider.node.find(".id");

		PanoSlider.controls = PanoSlider.node.find(".control");
		PanoSlider.previousBtn = PanoSlider.node.find(".control .l");
		PanoSlider.toggleBtn = PanoSlider.node.find(".control .t");
		PanoSlider.nextBtn = PanoSlider.node.find(".control .r");

		PanoSlider.holder = PanoSlider.node.find(".photoholder");
		PanoSlider.items = [];

		$(window).resize(PanoSlider.onresize);
	},

	placeLoaded: function(data) {
		if (player.current.place_type == "gallery") {
			PanoSlider.button.hide();
		} else {
			PanoSlider.button.show();
		}
	},

	go: function() {
		PanoSlider.close();
		var rot = "";
		if (PanoSlider.items[PanoSlider.idx].rotx != null) rot = PanoSlider.items[PanoSlider.idx].rotx;
		if (PanoSlider.items[PanoSlider.idx].rotx != null && PanoSlider.items[PanoSlider.idx].roty != null) rot = PanoSlider.items[PanoSlider.idx].rotx + "," + PanoSlider.items[PanoSlider.idx].roty;
		player.go(PanoSlider.items[PanoSlider.idx].id, rot);
	},

	close: function() {
		if (PanoSlider.nextCycle != null) {
			clearTimeout(PanoSlider.nextCycle);
			PanoSlider.nextCycle = null;
		}

		while (PanoSlider.imgs.length > 0) {
			var tmp = PanoSlider.imgs.shift();
			tmp.remove();
		}

		PanoSlider.node.detach();
		PanoSlider.cycling = false;
	},

	next: function() {
		if (!PanoSlider.cycling) {
			PanoSlider.idx ++;
			if (PanoSlider.idx >= PanoSlider.items.length) PanoSlider.idx = 0;
			PanoSlider.cycle();
		}
	},

	previous: function() {
		if (!PanoSlider.cycling) {
			PanoSlider.idx --;
			if (PanoSlider.idx < 0) PanoSlider.idx = PanoSlider.items.length - 1;
			PanoSlider.cycle();
		}
	},

	togglecycle: function() {
		PanoSlider.cycling = !PanoSlider.cycling;

		if (PanoSlider.cycling) {
			PanoSlider.previousBtn.css("opacity", "0.1");
			PanoSlider.nextBtn.css("opacity", "0.1");
			PanoSlider.previousBtn.css("cursor", "inherit");
			PanoSlider.nextBtn.css("cursor", "inherit");
			PanoSlider.toggleBtn.html("<i class='fa fa-pause'></i>");
			PanoSlider.toggleBtn.addClass("blinking");
			PanoSlider.cycle();
		} else {
			if (PanoSlider.nextCycle != null) {
				clearTimeout(PanoSlider.nextCycle);
				PanoSlider.nextCycle = null;
			}
			PanoSlider.previousBtn.css("opacity", "1");
			PanoSlider.nextBtn.css("opacity", "1");
			PanoSlider.previousBtn.css("cursor", "pointer");
			PanoSlider.nextBtn.css("cursor", "pointer");
			PanoSlider.toggleBtn.html("<i class='fa fa-play'></i>");
			PanoSlider.toggleBtn.removeClass("blinking");
		}
	},

	onresize: function() {
		var ratio = $(window).innerHeight() / $(window).innerWidth();
		var t = PanoSlider.node.find(".top");
		var b = PanoSlider.node.find(".bottom");

		t.css("height", (32 * ratio) + "%")
		b.css("height", (32 * ratio) + "%")
	},

	show: function() {
		$("#panels").append(PanoSlider.node);
		PanoSlider.cycling = false;

		Remote.ajax({
			url: "projectpanos.php?folder=" + player.folder,
			offline: "projectpanos.json",
			dataType:"json",
			success: function(response) {
				PanoSlider.items = response;
				PanoSlider.idx = 0;

				for(var i in PanoSlider.items) {
					if (PanoSlider.items[i].id == player.ident) {
						var ni = i;
						PanoSlider.idx = parseInt(i);
						while(PanoSlider.idx >= 0 && PanoSlider.items[PanoSlider.idx].id == PanoSlider.items[i].id)
							PanoSlider.idx--;					
						PanoSlider.idx ++;
					}
				}
				
				PanoSlider.togglecycle();
			}
		});

		/*
		$.getJSON("projectpanos.php?folder=" + player.folder, function(response) {
			PanoSlider.items = response;
			PanoSlider.idx = 0;

			for(var i in PanoSlider.items) {
				if (PanoSlider.items[i].id == player.ident) {
					var ni = i;
					PanoSlider.idx = parseInt(i);
					while(PanoSlider.idx >= 0 && PanoSlider.items[PanoSlider.idx].id == PanoSlider.items[i].id)
						PanoSlider.idx--;					
					PanoSlider.idx ++;
				}
			}
			
			PanoSlider.togglecycle();
		});
		*/

		PanoSlider.onresize();
	},

	cycle: function() {
		var img = new Image();

		if (PanoSlider.nextCycle != null) {
			clearTimeout(PanoSlider.nextCycle);
			PanoSlider.nextCycle = null;
		}
		
		PanoSlider.loader.show();

		img.onload = function() {
			var tclass = "img";
			if (PanoSlider.idx == 0 || PanoSlider.items[PanoSlider.idx].id != PanoSlider.items[PanoSlider.idx - 1].id) {
				tclass = "imgslide";
			}
			var iurl = PanoSlider.items[PanoSlider.idx].quality;
			if (player.offline) iurl = "data/" + PanoSlider.items[PanoSlider.idx].symbol;
			var img = $("<div class='" + tclass + "' onclick='PanoSlider.go();' style='background-image:url(" + iurl + ")'></div>");
			var prev = PanoSlider.imgs[PanoSlider.imgs.length - 1];
			PanoSlider.imgs.push(img);

			if (PanoSlider.imgs.length > 2) {
				var tmp = PanoSlider.imgs.shift();
				tmp.remove();
			}

			PanoSlider.holder.append(img);

			PanoSlider.counter.html((PanoSlider.idx + 1) + " / " + PanoSlider.items.length);
			var variant = TPL.lng("html5.variants." + PanoSlider.items[PanoSlider.idx].variant,'');
			//var variant = "html5.variants." + PanoSlider.items[PanoSlider.idx].variant;

			var title = PanoSlider.items[PanoSlider.idx].title;

			if (player.lang != undefined && player.lang != "PL" && player.lang != "" && PanoSlider.items[PanoSlider.idx].langs[player.lang]) {
				title = PanoSlider.items[PanoSlider.idx].langs[player.lang];
			}

			PanoSlider.title.html(title + (variant != "" ? " - <b style='color:green;'>" + variant + "</b>" : ""));
			PanoSlider.gps.html("N " + PanoSlider.items[PanoSlider.idx].gpsx + " &nbsp; E " + PanoSlider.items[PanoSlider.idx].gpsy);
			PanoSlider.idlabel.html("ID: " + PanoSlider.items[PanoSlider.idx].id);

			
			setTimeout(function() { 
				//console.log(img);
				img.addClass("in"); prev.addClass("out"); 
			}, 500);

			if (PanoSlider.cycling)	{
				PanoSlider.nextCycle = setTimeout(function() { 
					PanoSlider.idx ++;
					if (PanoSlider.idx >= PanoSlider.items.length) PanoSlider.idx = 0;
					PanoSlider.nextCycle = null; 
					PanoSlider.cycle(); 
				}, 5000);
			}

			PanoSlider.loader.hide();
		};

			if (player.offline) 
				img.src = "data/" + PanoSlider.items[PanoSlider.idx].symbol;
//				ia.src = "data/photo_" + this.properties.place_id + ".jpg";
//				ia.src = "data/screen_" + this.properties.place_id + ".jpg";
			else
				img.src = PanoSlider.items[PanoSlider.idx].quality;
	}
}

PluginManager.add(PanoSlider);